/* ==========================================================================
   OSERE — Carrusel de medios

   QUÉ HACE Y QUÉ NO.

   La pista se desliza SOLA: `scroll-snap` y `overflow-x` son CSS. Si este
   archivo no llega a ejecutarse —bloqueado, error de red, navegador viejo— el
   carrusel se sigue usando con el dedo y con la rueda, y las piezas se ven
   enteras. Lo que aporta el JS son tres comodidades: flechas, barra de
   progreso y visor. La mejora se añade, nunca se resta.

   ⚠️ POR QUÉ NO SE REUSA `<modal-dialog>` DE DAWN, que sí tiene trampa de foco.
   Su contrato es un modal por elemento con el contenido ya en el marcado; aquí
   el visor es UNO solo y su contenido cambia con la pieza que se abre. Forzarlo
   obligaba a renderizar N modales o a pelearse con `DeferredMedia`, que ya dio
   dos sorpresas en el vídeo del hero. La trampa de foco va escrita abajo, que
   son veinte líneas y hacen exactamente lo que hace falta.

   ⚠️ EL VÍDEO NACE SIN `src`. Se le pone al abrir y se le quita al cerrar. Un
   `preload="auto"` con la fuente puesta —lo que traía el original— descarga el
   archivo entero aunque nadie abra nada, y esta home va 70–80% móvil.
   ========================================================================== */

(function () {
  'use strict';

  var FOCO = 'a[href], button:not([disabled]), video[controls], [tabindex]:not([tabindex="-1"])';

  function montar(seccion) {
    /* Guarda de montaje. El personalizador emite shopify:section:load en CADA
       ajuste que toca la clienta, y sin esto se acumulaban escuchadores y
       —desde que hay avance automático— un setInterval por montaje: medido,
       cuatro montajes daban cuatro avances por tic. Cuando el personalizador
       reemplaza el nodo de verdad, el nuevo no trae el atributo y monta bien. */
    if (seccion.hasAttribute('data-os-montado')) return;
    seccion.setAttribute('data-os-montado', '');

    var pista = seccion.querySelector('[data-os-pista]');
    if (!pista) return;

    var piezas = seccion.querySelectorAll('[data-os-pieza]');
    if (!piezas.length) return;

    /* ---- 1. Progreso y flechas ---------------------------------------- */

    var relleno = seccion.querySelector('[data-os-progreso]');
    var anterior = seccion.querySelector('[data-os-anterior]');
    var siguiente = seccion.querySelector('[data-os-siguiente]');

    function sincronizar() {
      var x = pista.scrollLeft;
      var max = pista.scrollWidth - pista.clientWidth;
      if (relleno) {
        /* Un 2% de suelo para que la barra se vea desde el principio: a cero
           parece que no hay barra, no que estás al principio. */
        var pct = max > 0 ? Math.min(Math.max((x / max) * 100, 2), 100) : 100;
        relleno.style.inlineSize = pct + '%';
      }
      /* Margen de 2px: en pantallas con escala fraccionaria `scrollLeft` no
         llega nunca al máximo exacto y la flecha se quedaba viva al final. */
      if (anterior) anterior.disabled = x <= 2;
      if (siguiente) siguiente.disabled = x >= max - 2;
    }

    var pendiente;
    pista.addEventListener(
      'scroll',
      function () {
        if (pendiente) cancelAnimationFrame(pendiente);
        pendiente = requestAnimationFrame(sincronizar);
      },
      { passive: true }
    );
    sincronizar();

    function paso() {
      var primera = piezas[0].closest('[data-os-slide]') || piezas[0];
      var hueco = parseFloat(getComputedStyle(pista).columnGap) || 0;
      return primera.getBoundingClientRect().width + hueco;
    }

    if (anterior) anterior.addEventListener('click', function () { pista.scrollBy({ left: -paso() }); });
    if (siguiente) siguiente.addEventListener('click', function () { pista.scrollBy({ left: paso() }); });

    /* Al cambiar el ancho cambian las columnas visibles y con ellas el máximo
       de scroll: sin esto las flechas se quedan deshabilitadas de más. */
    if ('ResizeObserver' in window) new ResizeObserver(sincronizar).observe(pista);

    /* ---- 1 bis. Avance automático -------------------------------------- */

    /* Se apoya en el mismo `scrollBy` que las flechas, así que hereda el
       scroll-snap y no hay una segunda noción de "posición actual" que se
       pueda desincronizar de la barra de progreso.

       Cuatro razones para parar, y las cuatro importan:
       · el cursor encima o el foco dentro — estás leyendo un pie, no quieres
         que se te escape;
       · la pestaña en segundo plano — mover algo que nadie ve es gastar
         batería;
       · la sección fuera de pantalla — lo mismo, y además evita que al volver
         te encuentres el carrusel en un sitio que no dejaste;
       · `prefers-reduced-motion` — aquí ni siquiera se arranca el temporizador.

       Una interacción manual no lo apaga: reinicia la cuenta. Apagarlo del todo
       castiga al que usó las flechas, que es justo el que sí está mirando. */
    var autoMs = parseFloat(seccion.getAttribute('data-os-auto')) * 1000;

    if (autoMs > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var bucle = seccion.getAttribute('data-os-auto-bucle') !== 'false';
      var temporizador = null;
      var visible = true;
      var detenido = false;

      function puedeCorrer() {
        return !detenido && visible && !document.hidden;
      }

      function avanzar() {
        /* Si el personalizador reemplazó la sección, este temporizador quedó
           huérfano apuntando a un nodo fuera del documento: se apaga solo. */
        if (!seccion.isConnected) { detenido = true; parar(); return; }
        var max = pista.scrollWidth - pista.clientWidth;
        if (pista.scrollLeft >= max - 2) {
          if (!bucle) { detenido = true; parar(); return; }
          pista.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          pista.scrollBy({ left: paso(), behavior: 'smooth' });
        }
      }

      function arrancar() {
        parar();
        if (!puedeCorrer()) return;
        temporizador = setInterval(function () {
          if (!puedeCorrer()) { parar(); return; }
          avanzar();
        }, autoMs);
      }

      function parar() {
        if (temporizador) { clearInterval(temporizador); temporizador = null; }
      }

      seccion.addEventListener('pointerenter', parar);
      seccion.addEventListener('pointerleave', arrancar);
      seccion.addEventListener('focusin', parar);
      seccion.addEventListener('focusout', function (e) {
        if (!seccion.contains(e.relatedTarget)) arrancar();
      });

      /* Tocar las flechas o arrastrar la pista reinicia la cuenta, no la mata. */
      if (anterior) anterior.addEventListener('click', arrancar);
      if (siguiente) siguiente.addEventListener('click', arrancar);
      pista.addEventListener('pointerdown', parar);
      pista.addEventListener('pointerup', arrancar);

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) parar(); else arrancar();
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entradas) {
          visible = entradas[0].isIntersecting;
          if (visible) arrancar(); else parar();
        }, { threshold: 0.25 }).observe(seccion);
      } else {
        arrancar();
      }
    }

    /* ---- 2. Visor ------------------------------------------------------ */

    var visor = seccion.querySelector('[data-os-visor]');
    if (!visor) return;

    var lienzo = visor.querySelector('[data-os-visor-lienzo]');
    var cerrarBtn = visor.querySelector('[data-os-cerrar]');
    var devolverFoco = null;

    function vaciar() {
      var v = lienzo.querySelector('video');
      if (v) {
        v.pause();
        /* Quitar el `src` y recargar es lo que corta la descarga de verdad:
           con solo `pause()` el navegador sigue bajando el búfer. */
        v.removeAttribute('src');
        v.load();
      }
      lienzo.innerHTML = '';
    }

    function abrir(pieza) {
      var tipo = pieza.getAttribute('data-os-tipo');
      var src = pieza.getAttribute('data-os-src');
      if (!src) return;

      devolverFoco = pieza;
      vaciar();

      if (tipo === 'video') {
        var v = document.createElement('video');
        v.controls = true;
        v.playsInline = true;
        v.preload = 'metadata';
        v.setAttribute('controlslist', 'nodownload');
        var alt = pieza.getAttribute('data-os-poster');
        if (alt) v.poster = alt;
        v.src = src;
        lienzo.appendChild(v);
        var p = v.play();
        /* play() RECHAZA si el navegador bloquea el autoplay. Sin catch salta
           un error no capturado y parece que el visor está roto. */
        if (p && p.catch) p.catch(function () {});
      } else {
        var img = document.createElement('img');
        img.src = src;
        img.decoding = 'async';
        img.alt = pieza.getAttribute('data-os-alt') || '';
        lienzo.appendChild(img);
      }

      visor.hidden = false;
      document.documentElement.classList.add('os-carrusel-abierto');
      if (cerrarBtn) cerrarBtn.focus();
    }

    function cerrar() {
      if (visor.hidden) return;
      vaciar();
      visor.hidden = true;
      document.documentElement.classList.remove('os-carrusel-abierto');
      /* El foco vuelve a la pieza que abrió el visor. Sin esto aterriza al
         principio del documento y se pierde el sitio en el que se estaba. */
      if (devolverFoco) devolverFoco.focus();
      devolverFoco = null;
    }

    for (var i = 0; i < piezas.length; i++) {
      (function (pieza) {
        pieza.addEventListener('click', function () { abrir(pieza); });
      })(piezas[i]);
    }

    visor.addEventListener('click', function (e) {
      if (e.target === visor || (cerrarBtn && cerrarBtn.contains(e.target))) cerrar();
    });

    /* Trampa de foco. Mientras el visor está abierto el tabulador no puede
       salir de él: es lo que separa un modal de verdad de una capa encima. */
    visor.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { cerrar(); return; }
      if (e.key !== 'Tab') return;

      var focos = visor.querySelectorAll(FOCO);
      if (!focos.length) return;
      var primero = focos[0];
      var ultimo = focos[focos.length - 1];

      if (e.shiftKey && document.activeElement === primero) {
        e.preventDefault();
        ultimo.focus();
      } else if (!e.shiftKey && document.activeElement === ultimo) {
        e.preventDefault();
        primero.focus();
      }
    });
  }

  function init(raiz) {
    var secciones = (raiz || document).querySelectorAll('[data-os-carrusel]');
    for (var i = 0; i < secciones.length; i++) montar(secciones[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); }, { once: true });
  } else {
    init();
  }

  /* El personalizador reconstruye la sección al editarla y se lleva por delante
     los escuchadores. Sin esto, la clienta toca un ajuste y las flechas dejan
     de responder hasta recargar. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
